import { PSGIAQactions } from "./action";

const initialState = {
    AboutusandSections: {
        psgiaq: [],
        sections: [],
      },
};

export const psgiaqReducer = (state = initialState, action) => {
  switch (action.type) {
    case PSGIAQactions.SET_PSGIAQ_ABOUTUS_AND_SECTIONS:
      return {
        ...state,
        AboutusandSections: action.payload,
      };
    default:
      return state;
  }
};
